// @ts-nocheck

// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

interface EventFAQ {
  id: string;
  question: string;
  answer: string;
}

interface EventFAQSectionProps {
  eventId: string;
}

const EventFAQSection: React.FC<EventFAQSectionProps> = ({ eventId }) => {
  const [faqs, setFaqs] = useState<EventFAQ[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEventFAQs = async () => {
      try {
        console.log('📘 Fetching FAQs for event ID:', eventId);
        
        // First, get all FAQ IDs linked to this event
        const { data: faqLinks, error: linksError } = await supabase
          .from('event_faq_links')
          .select('faq_id')
          .eq('event_id', eventId);

        if (linksError) {
          console.error('Error fetching FAQ links:', linksError);
          setLoading(false);
          return;
        }

        if (!faqLinks || faqLinks.length === 0) {
          console.log('📘 No FAQ links found for event');
          setFaqs([]);
          setLoading(false);
          return;
        }

        // Extract FAQ IDs
        const faqIds = faqLinks.map(link => link.faq_id);
        console.log('📘 Found FAQ IDs:', faqIds);

        // Fetch the actual FAQ content
        const { data: faqData, error: faqsError } = await supabase
          .from('event_faqs')
          .select('id, question, answer')
          .in('id', faqIds)
          .order('created_at', { ascending: true });

        if (faqsError) {
          console.error('Error fetching FAQs:', faqsError);
          setLoading(false);
          return;
        }

        console.log('📘 Fetched FAQ data:', faqData);
        setFaqs(faqData || []);
      } catch (error) {
        console.error('Exception fetching event FAQs:', error);
      } finally {
        setLoading(false);
      }
    };

    if (eventId) {
      fetchEventFAQs();
    }
  }, [eventId]);

  // Don't render anything if no FAQs or still loading
  if (loading || faqs.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-xl p-6 shadow-md mb-6">
      <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
        📘 Frequently Asked Questions
      </h2>
      
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq, index) => (
          <AccordionItem key={faq.id} value={`faq-${index}`} className="border-b border-gray-200 last:border-b-0">
            <AccordionTrigger className="text-left hover:no-underline py-4">
              <span className="font-medium text-gray-900">{faq.question}</span>
            </AccordionTrigger>
            <AccordionContent className="pb-4">
              <div 
                className="text-gray-700 prose prose-sm max-w-none"
                dangerouslySetInnerHTML={{ __html: faq.answer }}
              />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default EventFAQSection;